<template>
  <div>
    <reference-field label="Authors">
      <template #actions>
        <v-btn
          v-if="hasAuthors"
          width="18"
          height="18"
          fab
          elevation="0"
          color="primary"
          @click="addAuthorField"
        >
          <v-icon size="18">add</v-icon>
        </v-btn>
      </template>
      <template v-if="hasAuthors">
        <author-input-field
          v-for="(author, i) in authors"
          :key="i"
          class="mb-2"
          :value="author"
          :autofocus="autofocus"
          :hide-remove="i === 0"
          @input="updateAuthorField(i, $event)"
          @remove="removeAuthorField(i)"
        />
      </template>
      <template v-else>
        <add-missing-value-chip @click="addAuthorField" />
      </template>
    </reference-field>
  </div>
</template>

<script>
import ReferenceField from '@/components/References/ReferenceField';
import AddMissingValueChip from '@/components/Common/AddMissingValueChip';
import AuthorInputField from './AuthorInputField';

export default {
  name: 'AuthorInputFieldList',
  components: {
    ReferenceField,
    AuthorInputField,
    AddMissingValueChip,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    authors: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    hasAuthors() {
      return this.authors && this.authors.length > 0;
    },
  },
  methods: {
    addAuthorField() {
      this.authors = this.authors.concat('');
    },
    removeAuthorField(index) {
      const authors = [...this.authors];
      authors.splice(index, 1);
      this.authors = authors;
    },
    updateAuthorField(index, value) {
      const authors = [...this.authors];
      this.$set(authors, index, value);
      this.authors = authors;
    },
  },
};
</script>
